/* ORAMA — product page: variants, gallery, bundles, per-eye, sticky bar */
(function () {
  'use strict';
  var root = document.querySelector('[data-product]');
  if (!root) return;

  var variants = [];
  try { variants = JSON.parse(document.getElementById('product-variants').textContent); } catch (e) {}

  var form = root.querySelector('[data-product-form]');
  var idInput = form && form.querySelector('[data-variant-id]');
  var qtyInput = form && form.querySelector('[name="quantity"]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var saveEl = root.querySelector('[data-save]');
  var addBtn = root.querySelector('[data-add-btn]');
  var addLabel = root.querySelector('[data-add-label]');
  var money = window.OramaFormatMoney || function (c) { return '$' + (c / 100).toFixed(2); };

  /* ---------- Variant selection ---------- */
  function selectedOptions() {
    var opts = [];
    root.querySelectorAll('[data-opt]').forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-opt-index'), 10);
      if (el.tagName === 'SELECT') { opts[idx] = el.value; }
      else if (el.type === 'radio') { if (el.checked) opts[idx] = el.value; }
    });
    return opts;
  }
  function findVariant(opts) {
    // Single-variant products (plano) render no [data-opt] controls — the
    // placeholder "Title" option is hidden — so option matching can't work;
    // resolve straight to the only variant.
    if (variants.length === 1 && !root.querySelector('[data-opt]')) return variants[0];
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function activeBundle() { return root.querySelector('[data-bundle].is-active'); }

  function render(variant) {
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; }
      if (addLabel) { addLabel.textContent = addBtn.getAttribute('data-unavailable'); }
      return;
    }
    if (idInput) idInput.value = variant.id;

    var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

    // Bundle row price — computed identically to Shopify's automatic discount
    // (discount = floor(base × pct), total = base − discount) so UI == checkout.
    function bundleTotal(base, pct) { return base - Math.floor(base * pct / 100); }
    root.querySelectorAll('[data-bundle]').forEach(function (tile) {
      var tq = parseInt(tile.getAttribute('data-bundle'), 10) || 1;
      var td = parseFloat(tile.getAttribute('data-discount')) || 0;
      var base = variant.price * tq;
      // Strike price = compare-at × qty (falls back to undiscounted total when no compare-at)
      var wasUnit = (variant.compare_at_price && variant.compare_at_price > variant.price) ? variant.compare_at_price : variant.price;
      var wasTotal = wasUnit * tq;
      var tp = tile.querySelector('[data-bundle-price]');
      var tw = tile.querySelector('[data-bundle-was]');
      var now = bundleTotal(base, td);
      if (tp) tp.textContent = money(now);
      if (tw) {
        if (wasTotal > now) { tw.textContent = money(wasTotal); tw.classList.remove('hide'); }
        else { tw.textContent = ''; tw.classList.add('hide'); }
      }
    });
    // Free-delivery line reflects the selected tier
    var freeEl = document.querySelector('[data-freedel]');
    if (freeEl) {
      var ab = activeBundle();
      freeEl.classList.toggle('hide', !(ab && ab.getAttribute('data-free') === '1'));
    }

    // Active tier discount applies to the headline total
    var bundle = activeBundle();
    var discount = bundle ? (parseFloat(bundle.getAttribute('data-discount')) || 0) : 0;
    var total = (variant.price * qty) - Math.floor(variant.price * qty * discount / 100);

    if (priceEl) priceEl.textContent = money(total);
    if (compareEl) {
      // Compare price = original (pre-bundle, pre-sale) so the saving is visible
      var base = (variant.compare_at_price && variant.compare_at_price > variant.price) ? variant.compare_at_price : variant.price;
      var baseTotal = base * qty;
      if (baseTotal > total) {
        compareEl.textContent = money(baseTotal);
        compareEl.classList.remove('hide');
        if (saveEl) {
          var pct = Math.round((1 - total / baseTotal) * 100);
          saveEl.textContent = '−' + pct + '%';
          saveEl.classList.remove('hide');
        }
      } else {
        compareEl.classList.add('hide');
        if (saveEl) saveEl.classList.add('hide');
      }
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available
        ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-soldout');
    }
    // sticky bar mirror
    var sPrice = document.querySelector('[data-sticky-price]');
    if (sPrice) sPrice.textContent = money(total);

    // swap gallery to variant image
    if (variant.featured_media_id) {
      var thumb = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
      if (thumb) thumb.click();
    }
    // update URL (no reload)
    if (history.replaceState && variant.id) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  function update() { render(findVariant(selectedOptions())); }
  root.querySelectorAll('[data-opt]').forEach(function (el) {
    el.addEventListener('change', update);
  });

  /* ---------- Quantity ---------- */
  root.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir = btn.getAttribute('data-qty-btn');
      var q = parseInt(qtyInput.value, 10) || 1;
      q = dir === 'up' ? q + 1 : Math.max(1, q - 1);
      qtyInput.value = q;
      update();
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', update);

  /* ---------- Bundle tiers ("buy more, save more") ---------- */
  root.querySelectorAll('[data-bundle]').forEach(function (opt) {
    opt.addEventListener('click', function () {
      root.querySelectorAll('[data-bundle]').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
      opt.classList.add('is-active'); opt.setAttribute('aria-checked', 'true');
      if (qtyInput) qtyInput.value = opt.getAttribute('data-bundle');
      update();
    });
  });

  /* ---------- Per-eye power (optional) ---------- */
  var perEyeToggle = root.querySelector('[data-per-eye-toggle]');
  if (perEyeToggle) {
    perEyeToggle.addEventListener('change', function () {
      root.querySelectorAll('[data-per-eye]').forEach(function (el) { el.classList.toggle('hide', !perEyeToggle.checked); });
      var single = root.querySelector('[data-single-power]');
      if (single) single.classList.toggle('hide', perEyeToggle.checked);
    });
  }

  /* ---------- Gallery ---------- */
  var mainImg = root.querySelector('[data-gallery-main]');
  root.querySelectorAll('[data-media-id]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      root.querySelectorAll('[data-media-id]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var full = thumb.getAttribute('data-full');
      if (mainImg && full) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = full; mainImg.alt = thumb.getAttribute('data-alt') || ''; }
      thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  });
  // arrows
  root.querySelectorAll('[data-gallery-nav]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-media-id]'));
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      var dir = btn.getAttribute('data-gallery-nav') === 'next' ? 1 : -1;
      var next = thumbs[(i + dir + thumbs.length) % thumbs.length];
      if (next) next.click();
    });
  });

  /* ---------- Sticky add-to-cart bar ---------- */
  var bar = document.querySelector('[data-sticky-bar]');
  var anchor = root.querySelector('[data-atc-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(anchor);
  }
  var stickyAdd = bar && bar.querySelector('[data-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', function () {
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  /* ---------- FAQ accordion ---------- */
  root.querySelectorAll('[data-faq-q]').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('[data-faq-item]');
      item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', item.classList.contains('is-open'));
    });
  });

  /* ---------- ViewContent pixel ---------- */
  var meta = root.getAttribute('data-product-meta');
  if (meta && window.oramaTrack) {
    try {
      var m = JSON.parse(meta);
      window.oramaTrack('ViewContent', { content_ids: [m.id], content_type: 'product', content_name: m.title, value: m.price / 100, currency: m.currency });
    } catch (e) {}
  }

  // initial paint
  update();

  /* ---------- Bundle Builder (slot flow — pick color, then degree, per box) ---------- */
  (function bundleBuilder() {
    var cfgEl = document.getElementById('bb-config');
    var dataEl = document.getElementById('bb-products');
    if (!cfgEl || !dataEl) return;
    var bbCfg = {}, bbProducts = [];
    try { bbCfg = JSON.parse(cfgEl.textContent); bbProducts = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var S = bbCfg.strings || {};
    var fmt = window.OramaFormatMoney || function (c) { return '$' + (c / 100).toFixed(2); };
    var slotsWrap = document.querySelector('[data-bb-slots]');
    var sheet = document.querySelector('[data-bb-sheet]');
    var overlay = document.querySelector('[data-bb-overlay]');
    var grid = document.querySelector('[data-bb-grid]');
    var titleEl = document.querySelector('[data-bb-title]');
    var motiveEl = document.querySelector('[data-bb-motive]');
    var pillEl = document.querySelector('[data-bb-pill]');
    var backBtn = document.querySelector('[data-bb-back]');
    var doneBtn = document.querySelector('[data-bb-done]');
    if (!slotsWrap || !sheet || !form || !addBtn) return;

    var st = { tier: 1, discount: 0, slots: [], active: -1, step: 1, color: -1 };

    function esc2(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function tmpl(str, n, t) { return String(str || '').replace('{{ n }}', n).replace('{{ t }}', t); }
    function filled() { return st.slots.filter(Boolean).length; }
    function bbOn() { return st.tier >= 2; }
    function bundleCents() {
      var sum = st.slots.reduce(function (a, s) { return a + (s ? s.price : 0); }, 0);
      return sum - Math.floor(sum * st.discount / 100);
    }

    function syncTier() {
      var tile = root.querySelector('[data-bundle].is-active');
      st.tier = tile ? (parseInt(tile.getAttribute('data-bundle'), 10) || 1) : 1;
      st.discount = tile ? (parseFloat(tile.getAttribute('data-discount')) || 0) : 0;
      var keep = st.slots.slice(0, st.tier);
      while (keep.length < st.tier) keep.push(null);
      st.slots = keep;
      renderSlots();
    }

    function renderSlots() {
      if (!bbOn()) {
        slotsWrap.classList.add('hide');
        slotsWrap.innerHTML = '';
        updateAddBtn();
        return;
      }
      slotsWrap.classList.remove('hide');
      slotsWrap.innerHTML = st.slots.map(function (slot, i) {
        if (slot) {
          return '<button type="button" class="bb-slot is-filled" data-bb-slot="' + i + '">' +
            '<span class="bb-slot__x" data-bb-clear="' + i + '" role="button" aria-label="remove">✕</span>' +
            (slot.img ? '<img src="' + esc2(slot.img) + '" alt="" loading="lazy">' : '') +
            '<span class="bb-slot__name">' + esc2(slot.color) + '</span>' +
            (slot.degree ? '<span class="bb-slot__deg">' + esc2(slot.degree) + '</span>' : '') +
            '<span class="bb-slot__price">' + esc2(fmt(slot.price)) + '</span>' +
          '</button>';
        }
        return '<button type="button" class="bb-slot is-empty" data-bb-slot="' + i + '">' +
          '<span class="bb-slot__plus">+</span>' +
          '<span class="bb-slot__label">' + esc2(S.slots[i] || ('Slot ' + (i + 1))) + '</span>' +
        '</button>';
      }).join('');
      updateAddBtn();
    }

    function updateAddBtn() {
      if (!bbOn()) return; // normal render() owns the button outside bundle mode
      var n = filled();
      if (n < st.tier) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = tmpl(S.progress, n, st.tier);
      } else {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = (S.addBundle || 'Add Bundle to Cart') + ' • ' + fmt(bundleCents());
      }
    }

    function openSheet(i) {
      st.active = i; st.step = 1; st.color = -1;
      renderSheet();
      sheet.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');
      sheet.setAttribute('aria-hidden', 'false');
    }
    function closeSheet() {
      sheet.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      sheet.setAttribute('aria-hidden', 'true');
    }

    function renderSheet() {
      var remaining = st.tier - filled();
      motiveEl.textContent = remaining > 0
        ? tmpl(st.tier >= 3 ? S.save20 : S.save10, remaining, st.tier)
        : (S.ready || '');
      pillEl.textContent = fmt(bundleCents()) + ' · ' + filled() + '/' + st.tier + ' 🛒';
      doneBtn.textContent = S.done || 'Done';
      if (st.step === 1) {
        titleEl.textContent = (S.slots[st.active] || '') + ' — ' + (S.pickColor || '');
        backBtn.classList.add('hide');
        grid.classList.remove('bb-grid--degrees');
        grid.innerHTML = bbProducts.map(function (p, i) {
          var out = p.variants.length === 0;
          return '<button type="button" class="bb-card' + (out ? ' is-out' : '') + '" data-bb-color="' + i + '"' + (out ? ' disabled' : '') + '>' +
            (p.img ? '<img src="' + esc2(p.img) + '" alt="" loading="lazy">' : '') +
            '<span class="bb-card__name">' + esc2(p.name) + '</span>' +
            '<span class="bb-card__price">' + (out ? esc2(S.soldOut || 'Sold out') : esc2(fmt(p.price))) + '</span>' +
          '</button>';
        }).join('');
      } else {
        var p = bbProducts[st.color];
        titleEl.textContent = p.name + ' — ' + (S.pickDegree || '');
        backBtn.textContent = S.back || 'Back';
        backBtn.classList.remove('hide');
        grid.classList.add('bb-grid--degrees');
        grid.innerHTML = p.variants.map(function (v, i) {
          return '<button type="button" class="bb-deg" data-bb-deg="' + i + '">' + esc2(v.t) + '</button>';
        }).join('');
      }
      var body = sheet.querySelector('.bb-sheet__body');
      if (body) body.scrollTop = 0;
    }

    function fillSlot(product, variant) {
      st.slots[st.active] = {
        vid: variant.id,
        price: variant.p,
        color: product.name,
        degree: (variant.t && variant.t !== 'Default Title') ? variant.t : '',
        img: product.img
      };
      renderSlots();
      var next = st.slots.indexOf(null);
      if (next === -1) { closeSheet(); }
      else { st.active = next; st.step = 1; st.color = -1; renderSheet(); }
    }

    document.addEventListener('click', function (e) {
      var clearBtn = e.target.closest('[data-bb-clear]');
      if (clearBtn) {
        e.preventDefault(); e.stopPropagation();
        st.slots[parseInt(clearBtn.getAttribute('data-bb-clear'), 10)] = null;
        renderSlots();
        return;
      }
      var slotBtn = e.target.closest('[data-bb-slot]');
      if (slotBtn) { openSheet(parseInt(slotBtn.getAttribute('data-bb-slot'), 10)); return; }
      var colorBtn = e.target.closest('[data-bb-color]');
      if (colorBtn && !colorBtn.disabled) {
        var ci = parseInt(colorBtn.getAttribute('data-bb-color'), 10);
        var p = bbProducts[ci];
        var single = p.variants.length === 1 && (!p.variants[0].t || p.variants[0].t === 'Default Title');
        if (!bbCfg.isMyopia || single) { fillSlot(p, p.variants[0]); }
        else { st.color = ci; st.step = 2; renderSheet(); }
        return;
      }
      var degBtn = e.target.closest('[data-bb-deg]');
      if (degBtn) {
        var p2 = bbProducts[st.color];
        if (p2) fillSlot(p2, p2.variants[parseInt(degBtn.getAttribute('data-bb-deg'), 10)]);
        return;
      }
      if (e.target.closest('[data-bb-back]')) { st.step = 1; st.color = -1; renderSheet(); return; }
      if (e.target.closest('[data-bb-close]') || e.target.closest('[data-bb-overlay]') || e.target.closest('[data-bb-done]')) { closeSheet(); return; }
      if (e.target.closest('[data-bundle]')) { setTimeout(syncTier, 0); }
    });

    // keep the button label correct after render() repaints (variant/option changes)
    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-product-form]')) setTimeout(updateAddBtn, 0);
    });

    // Bundle add-to-cart: capture phase so it wins over theme.js's single-item submit
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-product-form]');
      if (!f || !bbOn()) return;
      e.preventDefault();
      e.stopPropagation();
      if (filled() < st.tier) {
        var empty = st.slots.indexOf(null);
        if (empty !== -1) openSheet(empty);
        return;
      }
      var counts = {};
      st.slots.forEach(function (s) { counts[s.vid] = (counts[s.vid] || 0) + 1; });
      var items = Object.keys(counts).map(function (vid) {
        return { id: parseInt(vid, 10), quantity: counts[vid] };
      });
      addBtn.classList.add('is-loading'); addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) { throw r; } return r.json(); })
        .then(function () {
          if (window.oramaTrack) {
            window.oramaTrack('AddToCart', { value: bundleCents() / 100, currency: 'USD', contents: items.map(function (it) { return { id: it.id, quantity: it.quantity }; }) });
          }
          if (window.OramaCart) { return window.OramaCart.refresh().then(function () { window.OramaCart.open(); }); }
        })
        .catch(function () {
          var note = f.querySelector('[data-form-error]');
          if (note) { note.textContent = 'Could not add bundle to cart'; note.classList.remove('hide'); }
        })
        .finally(function () {
          addBtn.classList.remove('is-loading'); addBtn.disabled = false;
          updateAddBtn();
        });
    }, true);

    syncTier();
  })();
})();
